import React from "react";
import { Card, CardBody, Heading, Text, VStack } from "@chakra-ui/react";

const FactorCard = ({ title, description, result, accentColor = "blue.500" }) => {
  return (
    <Card
      h="100%"
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="2xl"
      bg="white"
      boxShadow="sm"
    >
      <CardBody>
        <VStack align="start" spacing={3}>
          <Heading size="sm" color={accentColor}>
            {title}
          </Heading>
          {result ? (
            <Text fontSize="sm" fontWeight="semibold" color="gray.800">
              {result}
            </Text>
          ) : null}
          {description ? (
            <Text color="gray.600" lineHeight="tall">
              {description}
            </Text>
          ) : null}
        </VStack>
      </CardBody>
    </Card>
  );
};

export default FactorCard;
